import { GET_DELIVERY_BOY_LIST } from "../actions/types"

const initialState = {
  deliveryBoyList: [],
}

export default (state = initialState, action) => {
  const payload = action.payload
  console.log(action)
  switch (action.type) {
    case GET_DELIVERY_BOY_LIST:
      return { ...state, deliveryBoyList: payload }
    default:
      return state
  }
}
